import styles from './Error.module.css'

export default function Error () {
  return (
    <div className={styles.errorContainer}>
      <div>
        No Screen Allocated
      </div>
    </div>
  )
}